import React, { useState, useEffect } from 'react'
import request from '../utils/request'
export default function ClearLocalStorage (props) {
  const [text, setText] = useState('点击清空localStorage')
  const [deleteAccount, setDeleteAccount] = useState('点击删除账号')
  const [localStorage, setLocalStorage] = useState(window.localStorage)
  function clear () {
    setText('已清空')
    console.log('清空localStorage了')
    window.localStorage.clear()
    setLocalStorage(window.localStorage)
  }

  useEffect(() => {
    console.log(window.localStorage)
    // eslint-disable-next-line
  }, [window.localStorage])

  function handleOnDeleteAcconut () {
    request(`/v1/orderers/logout`, {
      method: 'POST'
    }).then((res) => {
      console.log(res)
      setDeleteAccount('删除成功，返回首页，重新刷新')
    }).catch((error) => {
      console.log(error)
    })
  }

  return (
    <div>
      <div onClick={() => clear()}>{text}</div>
      <div>{JSON.stringify(localStorage)}</div>
      <div onClick={() => handleOnDeleteAcconut()} style={{ marginTop: 40 }}>
        {deleteAccount}
      </div>
    </div>
  )
}
